var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EditContactsPage',{attrs:{"get-gql-query":_vm.getGqlQuery,"get-total-count":_vm.getTotalCount,"get-contacts":_vm.getContacts,"get-query-variables":_vm.getQueryVariables,"update-query-variable":_vm.updateQueryVariable}})}
var staticRenderFns = []

export { render, staticRenderFns }